<template>
  <section class="card">
    <header class="head">
      <h2>修改密码</h2>
      <p class="sub">仅支持修改当前登录账号的密码。</p>
    </header>

    <p v-if="errorMsg" class="error">{{ errorMsg }}</p>
    <p v-if="okMsg" class="ok">{{ okMsg }}</p>

    <div class="form">
      <label class="field">
        <span>旧密码</span>
        <input v-model="oldPassword" type="password" autocomplete="current-password" placeholder="请输入旧密码" />
      </label>
      <label class="field">
        <span>新密码</span>
        <input v-model="newPassword" type="password" autocomplete="new-password" placeholder="6-64 位" />
      </label>
      <label class="field">
        <span>确认新密码</span>
        <input v-model="newPassword2" type="password" autocomplete="new-password" placeholder="再次输入新密码" />
      </label>
    </div>

    <div class="actions">
      <button class="btn btn-primary" :disabled="loading" @click="onSubmit">{{ loading ? '保存中...' : '保存' }}</button>
    </div>
  </section>
</template>

<script>
import { adminChangePassword, adminLogout, setAdminToken } from '@/api'

export default {
  name: 'ChangePasswordView',
  data() {
    return {
      loading: false,
      oldPassword: '',
      newPassword: '',
      newPassword2: '',
      errorMsg: '',
      okMsg: '',
    }
  },
  methods: {
    async onSubmit() {
      try {
        this.errorMsg = ''
        this.okMsg = ''
        const oldPassword = String(this.oldPassword || '').trim()
        const newPassword = String(this.newPassword || '').trim()
        const newPassword2 = String(this.newPassword2 || '').trim()
        if (!oldPassword) throw new Error('请输入旧密码')
        if (!newPassword || newPassword.length < 6) throw new Error('新密码至少 6 位')
        if (newPassword !== newPassword2) throw new Error('两次输入的新密码不一致')

        this.loading = true
        await adminChangePassword({ oldPassword, newPassword })
        this.okMsg = '密码已修改，请重新登录'

        // 修改密码后，清理本地会话并退出
        try {
          await adminLogout()
        } catch {
          // ignore
        }
        setAdminToken('')
        localStorage.removeItem('admin.profile')
        this.$router.replace('/login')
      } catch (e) {
        this.errorMsg = e?.message || '保存失败'
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.card { background: #fff; border-radius: 12px; padding: 16px; }
.head { margin-bottom: 10px; }
.sub { color: #667085; margin: 0; }
.error { color: #d92d20; margin: 10px 0; }
.ok { color: #067647; margin: 10px 0; }
.form { display: grid; grid-template-columns: 1fr; gap: 10px; max-width: 520px; }
.field { display: flex; flex-direction: column; gap: 6px; font-size: 13px; color: #344054; }
.field > span { font-weight: 700; }
input { border: 1px solid #d0d7e2; border-radius: 10px; padding: 10px 12px; background: #fff; }
.actions { margin-top: 12px; }
.btn { border-radius: 10px; padding: 8px 14px; cursor: pointer; border: 1px solid transparent; font-size: 13px; }
.btn-primary { background: #2f6af6; color: #fff; }
.btn[disabled] { opacity: 0.6; cursor: not-allowed; }
</style>

